function matches(element, selector) {
    if (!element || typeof selector != 'string' || element.nodeType != 1) {
        console.warn('Wrong or missing arguments in function `matches`');
        return null;
    }
    return (
        element.matches ||
        element.matchesSelector ||
        element.msMatchesSelector ||
        element.mozMatchesSelector ||
        element.webkitMatchesSelector ||
        element.oMatchesSelector
    ).call(element, selector);
}

function isNode(element) {
    return element.nodeType == 1;
}

function checkMatch(element, selector) {
    if (!selector) {
        selector = '*';
    }
    // Check if the element is a node and if it matches the selecor
    return isNode(element) && matches(element, selector);
}

function getParents(element, selector, topElement) {
    let parents = [];

    // If the element is not set or not a node return empty array
    if (!element || element.nodeType != 1) {
        return parents;
    }

    // If the top element is not set or not a node set it to document
    if (!topElement || topElement.nodeType != 1) {
        topElement = document;
    }
    let parentElement = element.parentNode;
    while (parentElement !== topElement) {
        if (checkMatch(parentElement, selector)) {
            parents.push(parentElement);
        }
        parentElement = parentElement.parentNode;
    }
    if (checkMatch(parentElement, selector)) {
        parents.push(parentElement);
    }

    return parents;
}

function nodeArray(selector, context) {
    if (!context) {
        context = document;
    }
    return [].slice.call(context.querySelectorAll(selector));
}

function getGrandChildren(element, filter) {
    let grandChildren = [];
    if (isNode(element)) {
        [].slice.call(element.children).forEach((child) => {
            [].slice.call(child.children).forEach((grandChild) => {
                if (!filter || (filter && checkMatch(grandChild, filter))) {
                    grandChildren.push(grandChild);
                }
            });
        });
    }
    return grandChildren;
}

function bubbleUntil(element, selectorOrElement = document.documentElement, returnAll = false) {
    const IS_STRING = typeof selectorOrElement == 'string';

    if (!element || element.nodeType != 1 || (!IS_STRING && !isNode(selectorOrElement))) {
        console.warn('Wrong or missing arguments in function `bubbleUntil`');
        return null;
    }

    let elements = [element];

    while (IS_STRING ? !matches(element, selectorOrElement) : element != selectorOrElement) {
        element = element.parentNode;
        elements.push(element);
        if (!isNode(element)) {
            return false;
        }
    }
    return returnAll ? elements : element;
}

let removeNode;
if (typeof document.body.remove == 'function') {
    removeNode = (element) => element.remove();
} else {
    removeNode = (element) => element.parentNode.removeChild(element);
}

export { getParents, checkMatch, isNode, matches, nodeArray, getGrandChildren, bubbleUntil, removeNode };
